import httpService from '../../service/httpService'
import store from '../../store'

export default {
  // 获取首页轮播图片
  async banner() {
    return httpService.get('/banner')
  },

  // 获取首页在线商城商品
  async goods_index() {
    return httpService.get('/goods-index')
  },
  // 获取首页抢购商品
  async goods_rush() {
    return httpService.get('/goods-rush')
  },
  // 获取首页团购商品
  async goods_group() {
    return httpService.get('/goods-group')
  },
  // 获取商品分类
  async goods_category() {
    return httpService.get('/goods-category')
  },
  // 获取商品列表
  async goods(obj) {
    return httpService.get('/goods',obj)
  },
  // 获取商品详情
  async goods_detail(id) {
    return httpService.get('/goods/'+id)
  },
  // 商城订单记录
  async goods_order_list(obj) {
    return httpService.get('/goods-order-list/',obj)
  },
  //购买商品
  async goods_pay(obj) {
    return httpService.post('/goods-pay',obj)
  },
  // 获取今日油价
  async price() {
    return httpService.get('/today-oil-price')
  },
  //获取加油员工
  async staff() {
    return httpService.get('/staff')
  },
  //获取油枪
  async oil_gun() {
    return httpService.get('/oil-gun')
  },
  //微信获取jssdk
  async jssdk(obj) {
    return httpService.get('/jssdk',obj)
  },
  //开奖信息
  async prize() {
    return httpService.get('/prize')
  },
  //中奖列表
  async prize_people(obj) {
    return httpService.get('/prize-people',obj)
  },
  //我的抽奖号码
  async user_prize(obj) {
    return httpService.get('/user-prize',obj)
  },
  //获取一键加油订单
  async oil_order(obj) {
    return httpService.post('/oil-order',obj)
  },
  //一键加油支付
  async oil_order_pay(obj) {
    return httpService.post('/oil-order-pay',obj)
  },
  //充值卡充值
  async refillable_card(obj) {
    return httpService.post('/refillable-card',obj)
  },
  //获取充值卡金额
  async card(obj) {
    return httpService.post('/card',obj)
  },
  //公告
  async notice() {
    return httpService.get('/notice')
  },
  //计算记录
  async distance(obj) {
    return httpService.post('/distance',obj);
  },
  //洗车券核销
  async washcar(obj) {
    return httpService.post('/washcar',obj)
  },
  //开发票
  async newinvoice(obj) {
    console.log('开发票参数', obj)
    return httpService.post('/nuonuo/newinvoice',obj)
  },
  //查询发票抬头
  async searchCompany(obj) {
    return httpService.post('/nuonuo/search',obj, false);
  },

  // 获取签名
  async getSignature() {
    store.commit('system/updateWxSignature', {
      app_id: res.data.config.app_id,
      jsapi_ticket: res.data.ticket.ticket
    });
    return res
  },
}



// WEBPACK FOOTER //
// ./src/api/system/index.js